<template>
  <!-- <v-btn value="dashboard" :to="{ name: 'dashboard'}" class="mybtn" active-class="mybtn-active">
      <span class="txt">Dashboard</span>
      <v-icon>mdi-monitor-dashboard</v-icon>
    </v-btn>

    <v-btn value="projects" :to="{ name: 'projects'}" class="mybtn" active-class="mybtn-active">
      <span class="txt">Projects</span>
      <v-icon>mdi-hard-hat</v-icon>
    </v-btn>

    <v-btn value="clients" :to="{ name: 'clients'}" class="mybtn" active-class="mybtn-active">
      <span class="txt">Clients</span>
      <v-icon>mdi-account-multiple</v-icon>
    </v-btn>

    <v-btn value="settings" :to="{ name: 'settings'}" class="mybtn" active-class="mybtn-active">
      <span class="txt">Settings</span>
      <v-icon>mdi-wrench</v-icon>
  </v-btn>-->
  <v-container fluid>
    <v-row v-if="showProjectFilter">
      <v-col cols="5"></v-col>
      <v-col cols="3">
        <v-select dense :items="statuses" v-model="selectedFilterStatus" hide-details></v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="filterTextClient"
          dense
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Client Search"
          class="hidden-sm-and-down"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="showClientFilter">
      <v-col cols="6"></v-col>
      <v-col cols="6">
        <v-text-field
          v-model="filterTextClient"
          dense
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
          class="hidden-sm-and-down"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      filterTextClient: "",
      selectedFilterStatus: "-- all --",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    showProjectFilter() {
      return this.$route.path == "/projects";
    },
    showClientFilter() {
      return this.$route.path == "/clients";
    },
    statuses() {
      let arr = ["-- all --"];
      arr = arr.concat(this.$store.getters.statuses);
      return arr;
    },
  },
  methods: {
    testA() {
      this.$router.push({ name: "projects" });
    },
  },
  watch: {
    filterTextClient(val) {
      this.$store.dispatch("setFilterTextClient", val);
    },
    selectedFilterStatus(val) {
      this.$store.dispatch("setFilterStatus", val);
    },
  },
};
</script>

<style lang="scss">
.mybtn {
  // background: green;
  border: 1px solid #a1a29e !important;
  margin-right: 7px !important;
}
.mybtn-active {
  background: #315a2c !important;
  border: 1px solid #497b3d !important;
}
.txt {
  margin-right: 5px;
}
</style>

